import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';
import Graficos from './Graficos';
import './css/dashboard.css';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import conexao from '../../Services/api';
const useStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: "0px 0x 0px 0px gray",
    borderRadius: "0px",
    height: "100%"
  },
  colorPaper: {
    backgroundColor: "#f9f9f9",
  }
}));

export default function Dashboard() {
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(localStorage.getItem('showModalUpdate') == 'false' ? false : true);

  function closeModal(){
    conexao.post(`/statusModalUpdate/${localStorage.getItem('userIdModalUpdate')}`, {showUpdateModal: 0}).then((response) => {
      setOpenModal(response.data.data.showUpdateModal == 0 ? false : true)
      localStorage.setItem('showModalUpdate', false);
    })
  }

  return (
    <div className={localStorage.getItem('containerClass')}>
      <Dialog
        open={openModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className='header-modal'> 
          <div>
            <span className='header-publication-date'>Publicado em: 27 de Janeiro/2024</span>
            <span className='header-update'>Nova atualização</span>
          </div>
          <CloseIcon className='header-close-icon' onClick={closeModal}/>
        </div>

        <div className='header-body'>

          <div className='header-update-type'>
            Novo Conteúdo
          </div>
          <div className='header-update-content'>
            <h2>Pacientes</h2>
            <ul>
              <li>Adicionado a opão de profissão no cadastro do cliente.</li>
              <li>Retirada a possibilidade de realizar um atendimento na página do paciente.</li>
            </ul>

            <h2>Agendamento</h2>
            <ul>
              <li>Recorrência de agendamentos alterada para cada 14 dias.</li>
              <li>Não é mais alterado o status do agendamento automaticamente após editar o agendamento.</li>
              <li>Criada a opção de "Visualizar prontuários" ao abrir um agendamento com o status "Realizado"</li>
              <li>Trocamos os textos "Gerar guia" por "Gerar Declaração".</li>
              <li>Quando estiver no perfil "Gerenciar Clínica", não é possível editar um agendamento sem selecionar um profissional.</li>
            </ul>
          </div>
        </div>


      </Dialog>
      <Graficos/>
    </div>
  );
}